import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { DemandPointProvider } from "./DemandPointContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <DemandPointProvider>
      <App />
    </DemandPointProvider>
  </React.StrictMode>,
);
